export const en = {
  'lang.name': 'English',
  'lang.select': 'Language',
  'app.skip': 'Skip to content',
  'theme.select': 'Theme',
  'settings.title': 'Settings',
  'settings.kicker': 'Quick',
  'settings.openAria': 'Open settings',
  'settings.closeAria': 'Close settings',
  'settings.backAria': 'Go back',
  'settings.soundLabel': 'Sound',
  'settings.soundHint': 'SFX for rolls, busts, tunnels, emotes.',
  'settings.soundAria': 'Toggle sounds',
  'settings.hapticsLabel': 'Vibration',
  'settings.hapticsHint': 'Vibration patterns for rolls, busts, and saves.',
  'settings.hapticsAria': 'Toggle vibration',
  'settings.themeLabel': 'Color scheme',
  'settings.typographyLabel': 'Theme',
  'settings.languageLabel': 'Language',
  'settings.refreshAction': 'Refresh',
  'settings.refreshing': 'Refreshing…',
  'settings.refreshDone': 'Refreshed',
  'settings.refreshFailed': 'No data',
  'theme.name.deep-sea': 'Deep Sea',
  'theme.name.ember-sunset': 'Ember Sunset',
  'theme.name.sage-meadow': 'Sage Meadow',
  'theme.name.dawn-mist': 'Dawn Mist',
  'theme.name.ultraviolet': 'Ultraviolet',
  'theme.name.rozy-roz': 'Rosey Rose',
  'theme.name.choco-pumpkin': 'Choco Pumpkin',
  'theme.name.flame': 'Flame',
  'theme.name.pizza': 'Pizza, pasta, buona sera',
  'theme.name.matrix': 'Matrix',
  'theme.name.rainbow': 'Rainbow',
  'theme.name.psychedellic': 'Psychedellic',
  'theme.name.ja-nie-wymyslam': 'I am not making this up',
  'typography.name.neon-circuit': 'Neon circuit',
  'typography.name.chakra-petch': 'Turbo grid',
  'typography.name.solar-grid': 'Solar grid',
  'typography.name.iron-press': 'Iron press',
  'home.title': 'Thousand Dice of Contention',
  'home.newGameShort': 'NEW GAME',
  'home.recordScores': 'RECORD SCORES',
  'home.scores': 'Game scores',
  'home.guide': 'Guide',
  'home.stats': 'Stats',
  'home.account': 'Account',
  'home.guideHint': 'Rules',
  'home.statsHint': 'Rolls',
  'home.accountHint': 'Profile',
  'home.scoresHint': 'History',
  'home.scenariosHint': 'Scenarios',
  'home.newGame': 'New Game (Reset)',
  'home.install': 'Install app',
  'home.iosHow': '📲 How to install on iOS',
  'home.ios.title': 'Install on iPhone / iPad:',
  'home.ios.step1': 'Open in Safari (required).',
  'home.ios.step2a': 'Tap the',
  'home.ios.step2b': '(square with the up arrow).',
  'home.ios.share': 'Share',
  'home.ios.step3': 'Choose “Add to Home Screen”.',
  'home.ios.step4': 'Confirm the name and tap “Add”.',
  'home.ios.after': 'After installation launch from the icon — the app runs fullscreen.',
  'header.tilesBar': 'Players bar',
  'header.tileLabel': '{name}, {score} points',
  'common.back': 'Back',
  'common.backToLobby': 'Back to lobby',
  'common.cancel': 'Cancel',
  'account.title': 'Account',
  'account.optionalTitle': 'Account is optional.',
  'account.optionalBody': 'You can keep playing anonymously and sign in later when you want to unlock account features.',
  'account.optionalFeature.stats': 'Private stats for your own games',
  'account.optionalFeature.friends': 'Friends and your personal player code',
  'account.optionalFeature.invites': 'Game invites and quick return to the lobby',
  'account.signInGoogle': 'Sign in with Google',
  'account.signInApple': 'Sign in with Apple',
  'account.signingIn': 'Redirecting to sign-in…',
  'account.signOut': 'Sign out',
  'account.signingOut': 'Signing out…',
  'account.delete.title': 'Delete account and data',
  'account.delete.subtitle': 'Tysiąc Kości Niezgody',
  'account.delete.appName': 'Tysiąc Kości Niezgody',
  'account.delete.publicNotice': 'Public account deletion request page',
  'account.delete.developerLabel': 'Developer:',
  'account.delete.developerName': 'Janek Rumianek',
  'account.delete.intro': 'This page is used to request deletion of a user account and related data for the Tysiąc Kości Niezgody app. Use the button below to open a prepared support e-mail.',
  'account.delete.scopeTitle': 'What gets deleted',
  'account.delete.scopeItem1': 'the user account and sign-in data linked to Tysiąc Kości Niezgody,',
  'account.delete.scopeItem2': 'private results, statistics, player profile, friends, and invites linked to that account,',
  'account.delete.scopeItem3': 'other account data stored only to operate app features, except data we must retain for legal or security reasons.',
  'account.delete.scopeFootnote': 'After the request is verified, data deletion is irreversible.',
  'account.delete.requestHint': 'The request text below is already prepared. If you are signed in, the account e-mail and user id are already filled in. If you are not signed in, enter the e-mail address used for your app account.',
  'account.delete.requestLabel': 'Request text',
  'account.delete.send': 'Send request by e-mail',
  'account.delete.copy': 'Copy request template',
  'account.delete.copyDone': 'Copied',
  'account.delete.afterSend': 'After sending the request to dice1k@outlook.com, you will receive confirmation at your account e-mail or as a reply to the message.',
  'account.delete.irreversible': 'Data deletion is irreversible.',
  'account.delete.loggedOutBody': 'You do not need to sign in to submit a request. If you open this page without a session, fill in the e-mail address used for your Tysiąc Kości Niezgody account and add your user id if you know it.',
  'account.delete.backHint': 'Do not want to delete data?',
  'account.delete.backAction': 'Back to account',
  'account.delete.mail.subject': 'Tysiąc Kości Niezgody - account data deletion request',
  'account.delete.mail.bodyIntro': 'Please delete my account and related data in the Tysiąc Kości Niezgody app.',
  'account.delete.mail.emailLabel': 'Account e-mail',
  'account.delete.mail.emailPlaceholder': '[enter account e-mail]',
  'account.delete.mail.userIdLabel': 'User id',
  'account.delete.mail.userIdPlaceholder': '[optional]',
  'account.delete.mail.detailsLabel': 'Details',
  'account.friendCode': 'Your code',
  'account.friendCodePending': 'Creating profile...',
  'account.displayName.placeholder': 'Enter player name',
  'account.displayName.save': 'Save name',
  'account.displayName.saving': 'Saving...',
  'account.displayName.saved': 'Name saved.',
  'account.displayName.length': 'Name must be between {min} and {max} characters.',
  'account.displayName.invalid': 'Name contains unsupported characters.',
  'account.userFallback': 'Player',
  'account.error.generic': 'Could not complete this action.',
  'account.error.notAuthenticated': 'This action requires a signed-in account.',
  'account.error.friendCodeRequired': 'Enter a valid friend code.',
  'account.error.friendNotFound': 'No player was found for that friend code.',
  'account.error.cannotAddYourself': 'You cannot add your own account as a friend.',
  'account.error.cannotInviteYourself': 'You cannot send a game invite to your own account.',
  'account.error.recipientNotFriend': 'Game invites can only be sent to accepted friends.',
  'account.error.gameGroupNotFound': 'Could not find an active lobby for this invite.',
  'account.error.recipientProfileNotFound': 'Could not find the recipient profile.',
  'account.error.friendRequestNotFound': 'That friend request is no longer available.',
  'account.error.gameInviteNotFound': 'That game invite is no longer available.',
  'account.status.loggedIn': 'Signed in',
  'account.status.loggedOut': 'Anonymous mode',
  'account.backToAccount': 'Back to account',
  'account.section.results.title': 'My results',
  'account.section.stats.title': 'My stats',
  'account.section.stats.loggedInBody': 'This private stats section now uses the new profile and participation model.',
  'account.section.stats.loggedOutBody': 'After sign-in, this section will show private stats for your own games.',
  'account.section.stats.lead': 'Overview',
  'account.section.stats.emptyTitle': 'No finished games yet',
  'account.section.stats.emptyBody': 'Once your first game is saved, this area will turn into a livelier overview of your personal stats.',
  'account.section.stats.group.results.title': 'Results',
  'account.section.stats.group.results.subtitle': 'How games tend to finish and what kind of final results appear most often.',
  'account.section.stats.group.tempo.title': 'Tempo',
  'account.section.stats.group.tempo.subtitle': 'Game rhythm, turn strength, and recent activity.',
  'account.section.stats.group.turnProfile.title': 'Turn profile',
  'account.section.stats.group.turnProfile.subtitle': 'The balance between positive, empty, and costly turns.',
  'account.section.stats.group.risk.title': 'Risk',
  'account.section.stats.group.risk.subtitle': 'Where the game bites back and where things get expensive.',
  'account.section.stats.group.patterns.title': 'Patterns and modes',
  'account.section.stats.group.patterns.subtitle': 'Straights, repeats, and the split between online and real games.',
  'account.section.friends.title': 'Friends',
  'account.section.social.title': 'Friends and invites',
  'account.section.friends.loggedOutBody': 'After sign-in, you will be able to add friends by code or invite link.',
  'account.friends.copyAction': 'Copy code',
  'account.friends.copyDone': 'Code copied',
  'account.friends.copyError': 'Could not copy the friend code.',
  'account.friends.shareAction': 'Share code',
  'account.friends.shareDone': 'Link copied',
  'account.friends.shareError': 'Could not share the friend code.',
  'account.friends.shareText': 'Add me as a friend in Dice1k. My code: {code}',
  'account.friends.form.label': 'Add friend by code',
  'account.friends.form.placeholder': 'Enter code',
  'account.friends.form.submit': 'Send request',
  'account.friends.form.submitting': 'Sending...',
  'account.friends.form.required': 'Enter a friend code before sending the request.',
  'account.friends.incomingTitle': 'Incoming',
  'account.friends.outgoingTitle': 'Outgoing',
  'account.friends.profile': 'Profile',
  'account.friends.remove': 'Remove',
  'account.friends.removeConfirm': 'Remove friend: {name}?',
  'account.friends.emptyIncoming': 'No incoming requests waiting for you.',
  'account.friends.emptyOutgoing': 'No outgoing requests are currently pending.',
  'account.friends.emptyFriends': 'You do not have accepted friends yet.',
  'account.friends.accept': 'Accept',
  'account.friends.reject': 'Reject',
  'account.friends.cancel': 'Cancel',
  'account.friends.status.pending': 'Pending',
  'account.friends.status.accepted': 'Accepted',
  'account.friends.status.rejected': 'Rejected',
  'account.friends.status.cancelled': 'Cancelled',
  'account.friends.notice.requestSent': 'Sent a request to: {name}.',
  'account.friends.notice.alreadyFriends': 'You are already friends with: {name}.',
  'account.friends.notice.alreadyPending': 'A request to {name} is already waiting for a reply.',
  'account.friends.notice.incomingPending': '{name} already sent you a request. Open incoming requests and accept it there.',
  'account.friends.notice.newIncoming': 'You have a new friend request.',
  'account.friends.notice.requestAccepted': 'Request accepted. The friendship is now active.',
  'account.friends.notice.requestRejected': 'Request rejected.',
  'account.friends.notice.requestCancelled': 'The outgoing request was cancelled.',
  'account.friends.notice.removed': 'Friend removed.',
  'account.friends.notice.generic': 'Friend action completed.',
  'account.friends.stats.games': 'Games',
  'account.friends.stats.wins': 'Wins',
  'account.friends.stats.losses': 'Losses',
  'account.friendStats.title': 'Player stats',
  'account.friendStats.emptyTitle': 'No finished games yet',
  'account.friendStats.emptyBody': 'This player does not have any saved games on this profile yet.',
  'account.section.invites.title': 'Invites',
  'account.invites.incomingTitle': 'Invites',
  'account.invites.outgoingTitle': 'Sent',
  'account.invites.emptyIncoming': 'No incoming game invites are waiting for you.',
  'account.invites.emptyOutgoing': 'You have not sent any game invites yet.',
  'account.invites.accept': 'Join',
  'account.invites.decline': 'Decline',
  'account.invites.cancel': 'Cancel',
  'account.invites.openLobby': 'Open lobby',
  'account.invites.status.pending': 'Pending',
  'account.invites.status.accepted': 'Accepted',
  'account.invites.status.declined': 'Declined',
  'account.invites.status.expired': 'Expired',
  'account.invites.status.cancelled': 'Cancelled',
  'account.invites.notice.newIncoming': 'You have a new game invite.',
  'account.invites.notice.accepted': 'Invite accepted. Opening the game lobby.',
  'account.invites.notice.declined': 'Game invite declined.',
  'account.invites.notice.cancelled': 'Game invite cancelled.',
  'online.invites.title': 'Invite friends',
  'online.invites.sendAction': 'Invite',
  'online.invites.sending': 'Sending...',
  'online.invites.notice.sent': 'Sent a game invite to: {name}.',
  'online.invites.notice.alreadyPending': 'There is already an active pending invite for: {name}.',
  'online.invites.notice.sentWithoutPush': 'Created a game invite for: {name}. The push notification was not delivered.',
  'online.invites.notice.sentPushFailed': 'Created a game invite for: {name}, but push delivery failed.',
  'online.invites.notice.accepted': '{name} accepted the invite.',
  'online.invites.notice.declined': '{name} declined the invite.',
  'online.invites.notice.expired': 'The invite for {name} expired.',
  'online.invites.notice.cancelled': 'The invite for {name} is no longer active.',
  'online.invites.entry.checking': 'Checking invite status...',
  'online.invites.entry.openAccount': 'Open account',
  'online.invites.entry.authRequired': 'This invite requires a signed-in account.',
  'online.invites.entry.authRequiredDetail': 'Sign in to continue with this invite.',
  'online.invites.entry.pending': 'Opening invite...',
  'online.invites.entry.pendingDetail': 'The app is accepting the invite and preparing the lobby.',
  'online.invites.entry.invalid': 'This invite can no longer be opened.',
  'online.invites.entry.invalidDetail': 'The link is invalid or the invite does not belong to this account.',
  'online.invites.entry.lookupFailed': 'Could not verify the invite status.',
  'online.invites.entry.expired': 'This invite has expired.',
  'online.invites.entry.declined': 'This invite was already declined.',
  'online.invites.entry.cancelled': 'This invite was cancelled.',
  'online.invites.entry.inactiveDetail': 'Return to Account and choose another active invite or ask the host for a new one.',
  'account.metrics.games': 'Games',
  'account.metrics.wins': 'Wins',
  'account.metrics.winRate': 'Win rate',
  'account.metrics.avgPlace': 'Avg place',
  'account.metrics.avgFinalScore': 'Avg final score',
  'account.metrics.bestPositivePoints': 'Best positive points',
  'account.metrics.maxTurn': 'Best turn',
  'account.metrics.avgTurnPoints': 'Avg per turn',
  'account.metrics.totalTurns': 'Total turns',
  'account.metrics.positiveTurns': 'Positive turns',
  'account.metrics.zeroTurns': 'Zero turns',
  'account.metrics.negativeTurns': 'Negative turns',
  'account.metrics.totalPositivePoints': 'Positive points',
  'account.metrics.totalNegativePoints': 'Negative points',
  'account.metrics.totalOvertakes': 'Overtakes',
  'account.metrics.longestPositiveStreak': 'Scoring streak',
  'account.metrics.longestNonPositiveStreak': 'Scoreless streak',
  'account.metrics.firstRollBusts': 'First-roll busts',
  'account.metrics.overThousandBusts': 'Busts above 1000',
  'account.metrics.missedStraights': 'Missed straights',
  'account.metrics.smallStraights': 'Straights 1-5',
  'account.metrics.largeStraights': 'Straights 2-6',
  'account.metrics.totalStraights': 'All straights',
  'account.metrics.exactTriples': 'Triples',
  'account.metrics.exactQuads': 'Quads',
  'account.metrics.exactQuints': 'Quints',
  'account.metrics.onlineGames': 'Online games',
  'account.metrics.realGames': 'Real games',
  'account.metrics.lastPlayedAt': 'Last game',
  'auth.callback.title': 'Signing in',
  'auth.callback.subtitle': 'Finalizing account sign-in and restoring session',
  'auth.callback.loading': 'Finishing sign-in…',
  'auth.callback.success': 'Sign-in complete. Redirecting…',
  'auth.callback.error': 'Could not finish sign-in.',
  'auth.callback.backToAccount': 'Back to account',
  'join.enterIdTitle': 'Enter Game ID',
  'join.enterIdHelp.online': 'Get the game ID from the host and enter your name',
  'join.enterIdHelp.real': 'Get the game ID from the host',
  'join.enterNameTitle': 'Enter your name',
  'join.enterNameHelp': 'We already have the game ID from your link — just share your name to join.',
  'join.mode.online': 'Online Game',
  'join.mode.real': 'In-person Game',
  'join.gameIdLabel': 'Game ID',
  'join.gameIdPlaceholder': 'Enter game ID...',
  'join.nameLabel': 'Your name (online)',
  'join.namePlaceholder': 'Enter name (2-20 characters)',
  'join.cta.joining': 'Joining...',
  'join.cta.join': 'Join Game',
  'join.howTitle': 'How to join:',
  'join.stepsOnline.1': 'Ask the host for the online lobby ID or game link',
  'join.stepsOnline.2': 'Enter the ID and your name (2-20 characters)',
  'join.stepsOnline.3': 'You will join the lobby and the game will start after order reveal',
  'join.stepsReal.1': 'Ask the host for the game ID or link',
  'join.stepsReal.2': 'Enter the ID above',
  'join.stepsReal.3': 'You will see the current game state',
  'join.stepsReal.4': 'Only the host can enter scores',
  'join.error.idRequired': 'Please enter a game ID',
  'join.error.nameRequired': 'Enter a name (2-20 characters)',
  'join.error.notFound': 'Game not found or invalid ID',
  'join.error.onlineJoin': 'Could not join the online game',
  'join.error.generic': 'Joining failed',
  'join.error.groupResolve': 'Could not find an active game for this group',
  'join.groupResolving': 'Checking your group’s latest game...',
  'join.groupResolved': 'Found your group – latest game: {gameId}',
  'add.hostNameLabel': 'Your name (Host)',
  'add.hostNamePlaceholder': 'Enter your name',
  'setup.start': 'Start Game',
  'game.wait.title': 'Player View',
  'game.wait.message': 'Waiting for the game to start or reconnect…',
  'game.wait.gameId': 'Game ID: {gameId}',
  'game.floatingId': 'Game ID',
  'game.focus.turnNumber': 'Current turn: {turn}',
  'game.focus.scoreLabel': 'Score',
  'game.focus.remainingLabel': 'Remaining',
  'game.recentEvents.kicker': 'Recent entries',
  'game.recentEvents.score': 'Score saved',
  'game.recentEvents.penalty': 'Penalty',
  'game.recentEvents.overtake': 'Overtake',
  'game.actionSummary.title': 'Current flow',
  'game.actionSummary.turnLabel': 'Turn',
  'game.actionSummary.rollLabel': 'Roll',
  'game.actionSummary.leaderLabel': 'Leader',
  'online.title': 'Online Game',
  'real.title': 'Score Tracking',
  'real.subtitle': 'Add players, arrange turn order, and start the game',
  'real.addPlayerTitle': 'Player name',
  'real.addPlayerPlaceholder': 'Enter player name',
  'real.addPlayerCta': 'Add player',
  'real.orderHint': 'Drag to arrange turn order',
  'real.selfHint': 'Optionally mark yourself so the finished game can be linked to your private account stats.',
  'real.selfAction': 'This is me',
  'real.selfSelected': 'ME',
  'online.share': 'Share the game link:',
  'online.shareFriendsTitle': 'Invite friends via link',
  'online.shareCtaTitle': 'Now share the game with other players',
  'online.shareCtaAction': 'Share link',
  'online.lastGameTitle': 'Last game finished',
  'online.lastGameSubtitle': 'The last round ended. Confirm the next-round roster in the same room.',
  'online.lastGameHint': 'Show the next-round roster first and keep the final standings below.',
  'online.showResults': 'Show final standings',
  'online.startNextGame': 'Start the next round',
  'online.waitForHostNext': 'The next-round roster updates live below.',
  'online.postGame.rosterTitle': 'Next-round roster',
  'online.postGame.rosterHint': 'Everyone can immediately see who signed up for the next round as a player.',
  'online.postGame.hostBadge': 'Host',
  'online.postGame.rolePlayer': 'Previous role: player',
  'online.postGame.roleViewer': 'Previous role: spectator',
  'online.postGame.statusPlayerReady': 'Confirmed for the next round',
  'online.postGame.statusPlayerPending': 'Not signed up for the next round',
  'online.postGame.statusViewerJoining': 'Will join the next round as a player',
  'online.postGame.statusViewerStaying': 'Not joining the next round as a player',
  'online.postGame.statusBotReady': 'Bot joins the next round',
  'online.postGame.resultsTitle': 'Final standings',
  'home.resumeOnlineTitle': 'You have an unfinished online game',
  'home.resumeOnlineHint': 'You can return to the active session or stay on the home screen.',
  'home.resumeOnlineAction': 'Resume game',
  'home.resumeOnlineDismiss': 'Not now',
  'online.joinTitle': 'Join the lobby',
  'online.joinCta': 'Join',
  'online.error.nextGame': 'Could not start the next round.',
  'online.createGame': 'Create game',
  'online.copied': 'Copied!',
  'settings.gameLinkLabel': 'Game link',
  'settings.gameLinkCopy': 'Share game link',
  'settings.gameLinkCopied': 'Copied!',
  'online.error.nameTaken': 'This name is already taken',
  'online.error.addPlayer': 'Could not add player.',
  'online.error.group': 'Could not prepare the group room. Started a local session instead.',
  'online.groupSyncPending': 'The room is ready. Syncing the share link and group metadata in the background.',
  'online.groupSyncFailed': 'The room works, but group metadata could not be synced yet.',
  'online.waitingMessage': 'Wait until the host starts the game.',
  'online.lobbySubtitle': 'Play online with other players and bots.',
  'online.exitConfirm': 'Are you sure you want to leave the lobby and return home?',
  'online.hostSubtitle': 'Play online with other players and bots.',
  'online.players': 'Players',
  'online.you': 'YOU',
  'online.ready.saving': 'Saving...',
  'online.ready.toggleSelf': 'Toggle your readiness',
  'online.ready.ready': 'READY',
  'online.ready.waiting': 'WAITING',
  'online.bot.tag': 'BOT',
  'online.bots.title': 'Add bot',
  'online.bots.profile.conservative': 'Conservative',
  'online.bots.profile.balanced': 'Balanced',
  'online.bots.profile.risky': 'Risky',
  'online.bots.variant.conservative': '🛡️ Cautious',
  'online.bots.variant.balanced': '⚖️ Neutral',
  'online.bots.variant.risky': '🎲 Risky',
  'online.bots.adding': 'Adding...',
  'online.bots.remove': 'Remove',
  'online.bots.removing': 'Removing...',
  'online.noPlayers': 'No players',
  'online.settingsTitle': 'Game settings',
  'online.settingsHostNote': 'Set by host',
  'online.rapid.title': 'Rapid mode',
  'online.rapid.enabled': 'Enabled',
  'online.rapid.freeThreshold': 'First interval',
  'online.rapid.baseBlock': 'Base penalty block',
  'online.rapid.minBlock': 'Minimum penalty block',
  'online.rapid.scalingMode': 'Scaling mode',
  'online.rapid.scaling.none': 'Static',
  'online.rapid.scaling.player-score': 'Player score',
  'online.rapid.scaling.turn-number': 'Turn number',
  'online.rapid.scaling.leader-score': 'Leader score',
  'online.rapid.summary': 'Rapid: free {threshold}, block {block}, min {min}, mode {mode}.',
  'online.tunnelsLabel': 'Tunnels',
  'online.tunnelsHint': 'Transition ranges 200-300 and 700-800',
  'online.rescueLabel': 'Rescue by five',
  'online.rescueHint': 'Sum divisible by 5 grants another roll',
  'online.zonesLabel': 'Zones',
  'online.zonesHint': 'Hidden bonus and penalty zones on the track; revealed on first hit',
  'online.zonesAvoidTunnelsLabel': 'Zones outside tunnels',
  'online.zonesAvoidTunnelsHint': 'Never place zones inside 200-300 and 700-800',
  'online.devSpectatorLabel': 'Play as Spectator (DEV)',
  'online.devSpectatorHint': 'Your turns auto-end instantly with 0 points.',
  'online.devSpectatorAria': 'Toggle play as spectator in dev mode',
  'online.devZeroDelayLabel': 'Zero Delay (DEV)',
  'online.devZeroDelayHint': 'Bots perform actions instantly without think delay.',
  'online.devZeroDelayAria': 'Toggle zero bot delay in dev mode',
  'online.shuffle': 'Shuffle order',
  'online.waitAll': 'Waiting for everyone to be ready',
  'online.startGame': 'Start game',
  'host.restore.title': 'Restoring game',
  'host.restore.message': 'Replaying events{ellipsis}',
  'host.restore.gameId': 'Game ID: {gameId}',
  'host.restore.retry': 'Try again',
  'order.dialogLabel': 'Revealed player order',
  'order.title': 'Revealed order',
  'order.begin': 'Start game',
  'order.wait': 'Waiting for host to start…',
  'join.viewerHint': 'If the game is already running, you will join as a viewer. The host can start the next round in the same room to refresh the lineup.',
  'online.spectators': 'Spectators',
  'online.restarting': 'Preparing next round…',
  'playerList.left': 'left the game',
  'scoreEntry.formLabel': 'Score entry',
  'scoreEntry.currentPlayer': 'Current player',
  'scoreEntry.confirm': 'Confirm',
  'scoreEntry.save': 'Save',
  'scoreEntry.saveSr': 'Save score',
  'scoreEntry.quickAria': 'Add {value}',
  'scoreEntry.undo': 'Undo',
  'scoreEntry.undoSr': 'Undo last',
  'scoreEntry.history.show': 'Show history',
  'scoreEntry.history.hide': 'Hide history',
  'playerList.aria': 'Player list',
  'playerList.title': 'Players',
  'playerList.remaining': 'Remaining: {points}',
  'playerList.tunnelExit200': 'Exit tunnel: {need}',
  'playerList.tunnelExit700': 'Exit tunnel: {need}',
  'playerList.lastTurn': 'Last turn',
  'playerList.stats.avg': 'Average',
  'playerList.stats.overtakes': 'Overtakes',
  'playerList.stats.busts': 'Busts',
  'playerList.stats.penalties': 'Penalties',
  'playerList.tags.rule3dice': '3-dice rule',
  'playerList.reason.firstZero': 'penalty for first bust',
  'playerList.reason.rapidTime': 'rapid penalty',
  'playerList.reason.zoneBonus': 'zone bonus',
  'playerList.reason.zonePenalty': 'zone penalty',
  'playerList.reason.and': 'and',
  'playerList.lastTurn.roll': 'from roll',
  'playerList.firstEntryPrompt': 'Score at least 50 points',
  'playerList.overtake.label': 'for overtake',
  'die.unrolled': 'Die not rolled yet',
  'die.value': 'Die: {value}{kept}',
  'die.kept': ' (kept)',
  'history.title': 'Game History',
  'history.close': 'Close history',
  'history.empty': 'No moves',
  'history.overtake': 'Overtook: {victims}',
  'history.turnAt': 'Turn {turn} • {time}',
  'history.pointsSuffix': 'pts',
  'history.zone.kind.bonus': 'bonus',
  'history.zone.kind.penalty': 'penalty',
  'history.zone.step': 'Zone {start}-{end} ({kind} {delta}): {from} → {to}',
  'history.zone.overtake': 'Overtake ({victims}): {bonus} → {to}',
  'history.zone.overtakeAnonymous': 'Overtake ({count}): {bonus} → {to}',
  'history.zone.voidedPrefix': '[loop] ',
  'history.zone.loop': 'Zone loop – player settles on the worst step: {score}',
  'rapid.progress.freeStage': 'First -5 pts',
  'rapid.progress.penaltyStage': 'Next -5 pts',
  'scores.title': 'Game Scores',
  'scores.subtitle': 'Summary of recent sessions',
  'scores.privateTitle': 'My results',
  'scores.privateSubtitle': 'Here you will find details of all your games.',
  'scores.privateLoggedOutBody': 'This section is available only after sign-in.',
  'scores.privateEmpty': 'You do not have any saved games on this account yet.',
  'scores.loading': 'Loading scores…',
  'scores.empty': 'No data',
  'scores.emptyRecent': 'No game data recently.',
  'scores.prev': 'Previous',
  'scores.next': 'Next',
  'scores.page': 'Page {page}',
  'scores.deleteHint': 'Delete actions are available only on the local dev environment.',
  'scores.deleteGameAction': 'Delete game',
  'scores.deleteSessionAction': 'Delete session',
  'scores.deletePending': 'Deleting…',
  'scores.deleteGameError': 'Failed to delete this game.',
  'scores.deleteSessionError': 'Failed to delete this session.',
  'scores.table.rank': '#',
  'scores.table.player': 'Player',
  'scores.table.score': 'Score',
  'scores.table.posPoints': '+ pts',
  'scores.table.negPoints': '- pts',
  'scores.table.posTurns': '+ turns',
  'scores.table.zeroTurns': '0 turns',
  'scores.table.negTurns': '- turns',
  'scores.table.turnMix': 'Turn mix',
  'scores.table.busts': 'Busts',
  'scores.table.missedStraights': 'Missed straights',
  'scores.table.maxTurn': 'Best turn',
  'scores.session.label': 'Session',
  'scores.session.games': 'Games',
  'scores.session.wins': 'Wins',
  'scores.session.avgPlace': 'Avg place',
  'scores.session.histogram': 'Place histogram',
  'scores.session.totalPoints': 'Total points',
  'results.title': 'Game results',
  'results.subtitle': 'Detailed stats for game {id}',
  'results.loading': 'Loading game data…',
  'results.error': 'Unable to load this game.',
  'results.noEvents': 'No events recorded for this game.',
  'results.deleteAction': 'Delete test game',
  'results.deletePending': 'Deleting…',
  'results.deleteConfirm': 'Delete game {id} and all related data? This cannot be undone.',
  'results.deleteHint': 'Visible only on the dev server.',
  'results.deleteError': 'Failed to delete this game.',
  'results.metricsTitle': 'Player metrics',
  'results.metricsHeader': 'Metric',
  'results.metric.avg.desc': 'Average points per turn.',
  'results.metric.avgPositive.desc': 'Average points on scoring turns.',
  'results.metric.maxTurn.desc': 'Best single-turn score.',
  'results.metric.totalPositive.desc': 'Total positive points.',
  'results.metric.penalties.desc': 'Turns ending with a negative score.',
  'results.metric.overtakePenalties.desc': 'Points lost due to overtakes.',
  'results.metric.zerosNeg.desc': 'Zero or negative turns.',
  'results.metric.streakPos.desc': 'Longest positive streak.',
  'results.metric.streakNonPos.desc': 'Longest non-positive streak.',
  'results.metric.firstEntry.desc': 'Turn of first 50+ entry.',
  'results.metric.stdDev.desc': 'Score variability per turn (lower = steadier).',
  'results.metric.pointsShare.desc': 'Share of total positive points.',
  'results.metric.firstRollBusts.desc': 'First-roll busts.',
  'results.metric.overThousandBusts.desc': 'Overshot 1000.',
  'results.metric.missedStraights.desc': 'Straights total/skipped.',
  'stats.title': 'Dice stats',
  'stats.subtitle': 'Aggregated statistics for all games. Updated once a day.',
  'stats.refreshedAt': 'Last recalculation: {timestamp}',
  'stats.error': 'Failed to load stats',
  'stats.noData': 'No data to show.',
  'stats.rollEvents': 'Recorded rolls',
  'stats.totalDice': 'Dice captured',
  'stats.faces.title': 'Face distribution (1–6)',
  'stats.faces.subtitle': 'Occurrences and share',
  'stats.faces.name1': 'One',
  'stats.faces.name2': 'Two',
  'stats.faces.name3': 'Three',
  'stats.faces.name4': 'Four',
  'stats.faces.name5': 'Five',
  'stats.faces.name6': 'Six',
  'stats.positions.title': 'Dice by position 1–5',
  'stats.positions.subtitle': 'Which values dominate on each slot',
  'stats.positions.positionPrefix': 'Position',
  'stats.triples.title': 'Triples, quads and quints',
  'stats.triples.subtitle': 'Only patterns rolled in a single throw are counted, separately for each face value.',
  'stats.triples.kindThree': 'Three dice',
  'stats.triples.kindFour': 'Four dice',
  'stats.triples.kindFive': 'Five dice',
  'stats.straights.title': 'Straights (1–5 and 2–6)',
  'stats.straights.subtitle': 'All straights are counted, both noticed and unnoticed.',
  'stats.theory.triplets.title': 'Compared with theory',
  'stats.theory.triplets.subtitle': 'Compares observed patterns with mathematical odds, but only when roll-size data is available.',
  'stats.theory.observed': 'Observed',
  'stats.theory.theoretical': 'Theory',
  'stats.theory.difference': 'Difference',
  'stats.theory.sample': 'Sample',
  'stats.gameLength.title': 'Game length (turns)',
  'stats.gameLength.subtitle': 'Distribution of turns across completed games.',
  'stats.gameLength.games': 'Games',
  'stats.gameLength.avg': 'Average',
  'stats.gameLength.min': 'Minimum',
  'stats.gameLength.max': 'Maximum',
  'stats.gameLength.total': 'Total turns',
  'stats.bots.title': 'Bot performance',
  'stats.bots.profiles': 'Bot profiles',
  'stats.bots.subtitle': 'Profile ranking based on completed games, with placement normalized to table size.',
  'stats.bots.best': 'Best bot',
  'stats.bots.worst': 'Worst bot',
  'stats.bots.none': 'No data',
  'stats.bots.appearances': 'Appearances',
  'stats.bots.games': 'Games',
  'stats.bots.wins': 'Wins',
  'stats.bots.winRate': 'Win rate',
  'stats.bots.relativePlace': 'Relative place',
  'stats.bots.avgPlace': 'Avg place',
  'stats.bots.avgScore': 'Avg final score',
  'stats.rollsLabel': 'rolls',
  'error.title': 'Something went wrong',
  'error.message': 'An error occurred. Refresh the page to try again.',
  'error.refresh': 'Refresh page',
  'guide.title': 'Guide',
  'guide.subtitle': 'App usage and game rules in one place.',
  'guide.about.title': 'What this game is',
  'guide.about.p1': 'Thousand Dice of Contention is a push-your-luck game: on your turn you roll, keep scoring dice, and decide whether to risk another roll or bank the score.',
  'guide.about.p2': 'The goal is to reach exactly 1000 points. Overtakes, tunnels, and penalties can speed the game up or slow it down.',
  'guide.rules.title': 'Game rules',
  'guide.rules.scoringTitle': 'Rules and scoring',
  'guide.rules.p1': 'At the start of a turn you roll five dice and check which ones score. 1s (10 pts) and 5s (5 pts) always score, as do sets of at least three identical dice rolled in the same throw. For example, rolling 1, 1, 1, 5, 5 in a single throw gives 110 points (100 for three 1s and 5 for each 5).',
  'guide.rules.p2': 'Sets: three 1s = 100 pts, four = 200, five = 400. For other values: 3×X = 10×X pts, 4×X = 20×X pts, 5×X = 40×X pts.',
  'guide.rules.table': '3×1 = 100, 4×1 = 200, 5×1 = 400\n3×2 = 20, 4×2 = 40, 5×2 = 80\n3×3 = 30, 4×3 = 60, 5×3 = 120\n3×4 = 40, 4×4 = 80, 5×4 = 160\n3×5 = 50, 4×5 = 100, 5×5 = 200\n3×6 = 60, 4×6 = 120, 5×6 = 240',
  'guide.rules.p3': 'Like in Ludo, you must meet the entry condition: your first banked score must be at least 50 points. The condition for banking points is that at least three scoring dice remain “on the table”. After each roll, you must leave at least one scoring die on the table to reroll the rest. If you reach a state where all five dice on the table are scoring, you may, but do not have to, roll all dice again. You can bank and end your turn at any time, as long as at least three dice are scoring and your latest roll is not a bust. Exceptions are tunnels (200–300 and 700–800) and the safe zone (from 900).',
  'guide.rules.p4': 'No scoring dice in a roll means a bust: the whole turn scores 0 points, and a first-roll bust adds an extra −50 penalty. Below 900 points, you need at least three scoring dice to bank.',
  'guide.overtake.overtakeTitle': 'Overtakes',
  'guide.overtake.overtakeBody': 'Overtaking another player after banking gives +50 points to the overtaker, and the overtaken player loses 50 points. This happens when your banked score passes another player’s score. If another player passes your score, you lose 50 and they gain 50. Overtake bonuses apply only below 900 points. In the safe zone (900+) there are no penalties or bonuses, but overtaking is still possible.',
  'guide.overtake.tunnelsTitle': 'Tunnels',
  'guide.overtake.tunnelsBody': 'Tunnels are the 200–300 and 700–800 ranges (inclusive). If you land in a tunnel (you stop at a score from 200 to 300 or from 700 to 800), in your next turn you must score enough to reach at least the end of the tunnel. If you do not pass its upper boundary, you stay at the same score. If you pass the upper tunnel boundary, you exit the tunnel and continue normally.',
  'guide.overtake.safeEndTitle': 'Safe zone and game end',
  'guide.overtake.safeEndBody': 'The safe zone starts at 900 points. In this zone you no longer lose points when overtaken and you no longer gain the bonus for overtaking. You may also bank with just one scoring die; the 3-dice minimum no longer applies. There is also no first-roll bust penalty. You win only if your banked score reaches exactly 1000—going over 1000 cancels the turn’s points.',
  'guide.zones.title': 'Zones',
  'guide.zones.intro': 'Zones are an option the host turns on in the game settings—it works the same in REAL and ONLINE mode. With it on, six hidden stretches sit somewhere on the track: three bonus ones and three penalty ones. Nobody knows where. A zone is revealed only once someone lands on it, and from that moment everyone sees it for the rest of the game.',
  'guide.zones.ladderBody': 'Only the position is random. Strength and width are fixed, on a ladder: the stronger the effect, the narrower—and therefore the harder to hit—the zone.',
  'guide.zones.table': 'Tier I: ±60 points, width 5 — 2 reachable scores\nTier II: ±40 points, width 10 — 3 reachable scores\nTier III: ±20 points, width 15 — 4 reachable scores',
  'guide.zones.placementBody': 'Zones fit between 100 and 895 points, so they never reach into the safe zone, and at least 25 points separate any two of them. A separate option, “Zones outside tunnels”, additionally keeps them away from the 200–300 and 700–800 ranges.',
  'guide.zones.triggerTitle': 'When a zone fires',
  'guide.zones.triggerBody': 'A zone fires if and only if your marker comes to rest on it. Merely passing through does nothing. It is checked against your final score for the turn: after banking, after any time penalty, and after overtakes. The jump out of a zone is an ordinary move along the track, so it can overtake other players on the usual terms: +50 for you, −50 for the player you pass.',
  'guide.zones.chainTitle': 'Zone chains',
  'guide.zones.chainBody': 'If the jump out of a zone—together with any overtake bonus it triggered along the way—puts your marker on another zone, that one fires too. And so on, until your marker rests outside every zone. Overtakes are counted separately for each link of the chain, but you can overtake the same opponent at most once per turn. If the chain starts to loop, meaning the route returns to a score it already rested on, it ends there and you stay on the worst score inside that loop.',
  'guide.zones.limitsBody': 'A zone penalty never drops you below zero, nor below the first-entry threshold of 50 points. The jump out of a zone is not subject to the tunnel rule. A link that would push you above 1000 simply does not happen and ends the chain—so a hidden zone cannot ruin a turn you judged to be safe. The one exception is a zone landing you exactly on 1000: that wins the game. For the same reason, the over-1000 hint never accounts for zones.',
  'guide.app.title': 'How to use the app',
  'guide.app.quickStartTitle': 'Quick online start',
  'guide.app.hostTitle': 'Host (player creating the lobby)',
  'guide.app.hostStep1': 'Open Play Online.',
  'guide.app.hostStep2': 'Enter your nickname and click Save.',
  'guide.app.hostStep4': 'Share the game using Share link or invite accepted friends directly from the lobby. You can also add bots to fill the roster.',
  'guide.app.hostStep5': 'Wait until all players join and are ready.',
  'guide.app.hostStep6': 'When everyone is ready, the host shuffles the order and starts the game.',
  'guide.app.joinTitle': 'Joining player',
  'guide.app.joinStep1': 'Click the received share link or invite link. The app window will open.',
  'guide.app.joinStep2': 'Enter your nickname.',
  'guide.app.joinStep3': 'Click Join.',
  'guide.app.joinStep4': 'After joining, your status is automatically set to Ready.',
  'guide.app.joinStep5': 'If you need more time, you can switch your status to Waiting.',
  'guide.app.onlineTitle': 'Online mode',
  'guide.app.onlineBody': 'One player creates the lobby, becomes the host, and shares the game link. The host can also send invites to accepted friends directly from the lobby. Everyone joins with a name. When all players are ready, the host starts the game. Once the game is in progress, new arrivals join as spectators; results remain visible for everyone after the game ends.',
  'guide.app.realTitle': 'Scorekeeping mode',
  'guide.app.realBody': 'You can also play with physical dice while the app enforces the rules and keeps score for you. Add players, configure rules, and start the game. Enter turn scores, and at the end you get full statistics. You can also share the scorekeeping-mode game link so others can follow the game live.',
  'guide.app.accountTitle': 'Account, friends, and invites',
  'guide.app.accountBody': 'Accounts are optional. Signing in with Google or Apple unlocks your personal game list, private stats, the friends list based on `friend_code`, and game invites. Anonymous gameplay still works without an account.',
  'guide.app.accountDetailsBody': 'In Account you can open My Results for your own finished games, My Stats for the private summary of your play, and the social view for friends plus active invites. Invite links now take you straight into the right lobby flow instead of stopping at a separate accept screen.',
  'guide.app.accountPushBody': 'Game invites can appear as push notifications. Tapping a notification opens the app in the right lobby.',
  'guide.app.botsTitle': 'Bots',
  'guide.app.botsIntro': 'Bots let you quickly fill empty seats when there are not enough human players. A bot is a full participant in the game: it has its own score, takes turns normally, can overtake others, and can also be overtaken.',
  'guide.app.botsAddTitle': 'How to add a bot',
  'guide.app.botsAddBody': 'In the lobby, the host can add one or more bots before the game starts. A bot appears on the player list immediately and is ready to play. If you add multiple bots of the same type, the app gives them distinct names.',
  'guide.app.botsBehaviorTitle': 'How bots behave',
  'guide.app.botsBehaviorBody': 'A bot takes its actions automatically when its turn comes. It decides which scoring dice to keep and whether to bank the turn or risk another roll. Bots follow the same rules as human players and do not get any hidden advantages.',
  'guide.app.botsProfilesTitle': 'Bot profiles',
  'guide.app.botsProfileAsekuro': 'Asekuro: plays cautiously, banks points more often, and is less willing to extend a risky turn.',
  'guide.app.botsProfileNeutralo': 'Neutralo: plays the most evenly, without leaning too hard toward either caution or aggression.',
  'guide.app.botsProfileRyzykanto': 'Ryzykanto: pushes more often, stays in turns longer, and accepts bigger swings in outcome.',
  'guide.app.botsNotesTitle': 'Important notes',
  'guide.app.botsNotesBody': 'Bots do not replace the host. The host still starts the game and manages the lobby. Once the game begins, the lineup is locked just like it is for regular players. In end-of-game statistics, bots are treated like normal participants and their results count toward the full summary.',
  'layout.main': 'Main section',
  'layout.mainWithTitle': 'Main section: {title}',
  'gameOver.winner': 'Winner: {name}',
  'gameOver.newGame': 'New game',
  'gameOver.exitConfirm': 'End the game and return to the home screen?',
  'gameOver.resultsMissing': 'Unable to load results. Try again or open the results page.',
  'gameOver.openResults': 'Open results',
  'gameOver.resultsCalculating': 'Preparing final results…',
  'gameOver.exactThousand': 'Exactly 1000 points',
  'gameOver.endedIn': 'Game ended in {turns} turns',
  'gameOver.nextGame.starting': 'Preparing next round…',
  'gameOver.nextGame.startAction': 'Start the next round',
  'gameOver.nextGame.updateError': 'Could not update participation for the next round.',
  'gameOver.nextGame.selectedCount': '{count} participants are in for the next round.',
  'gameOver.nextGame.noneSelected': 'No one has joined the next round yet.',
  'gameOver.nextGame.viewersPromoted': 'Spectators joining the lineup: {names}',
  'gameOver.nextGame.pendingPlayers': 'Active players not signed up for the next round: {names}',
  'gameOver.nextGame.hostReady': 'The host can start the next round now.',
  'gameOver.nextGame.hostNeedMin': 'At least 2 confirmed participants are needed to start the next round.',
  'gameOver.nextGame.updating': 'Updating…',
  'gameOver.nextGame.optOut': 'Withdraw confirmation',
  'gameOver.nextGame.optIn': 'Confirm participation',
  'gameOver.rankings': 'Final Rankings',
  'gameOver.winnerBadge': 'Winner!',
  'gameOver.pointsLabel': 'points',
  'gameOver.quickSummary': 'Quick summary',
  'gameOver.bestAvg': 'Best avg / turn',
  'gameOver.bestTurn': 'Highest single turn',
  'gameOver.mostPenalties': 'Most penalties',
  'gameOver.longestStreak': 'Longest positive streak',
  'gameOver.gameStats': 'Game stats',
  'gameOver.totalTurns': 'Total turns',
  'gameOver.overtakes': 'Overtakes',
  'gameOver.topPlays': 'Top plays',
  'gameOver.turnLabel': 'Turn {turn}',
  'gameOver.raceTitle': 'Race replay',
  'gameOver.play': 'Play',
  'gameOver.pause': 'Pause',
  'turn.save': 'Save',
  'turn.tunnelNeed': 'Need {need}',
  'turn.overWin': 'Bust!',
  'turn.roll': 'Roll',
  'turn.rollAgain': 'Roll again',
  'turn.instruction': 'Select scoring dice to roll again.',
  'game.roll.pointsOnTable': '{points} pts',
  'game.roll.keepRequired': 'Select at least one scoring die.',
  'game.roll.nonScoringKept': 'Non-scoring dice are in play – remove them or select a full combination.',
  'game.bank.nonScoringKept': 'Non-scoring dice are in play – remove them or complete a combo (e.g. a straight).',
  'game.bank.winRequiresAllScoring': 'To finish the game, keep all scoring dice from the last roll or roll again.',
  'game.bank.belowThreeScoringEndTurn': 'To save your score you need at least three scoring dice (≥3).',
  'game.bank.belowThreeScoringBank': 'Below 900 you need ≥3 scoring dice – banking now would score 0.',
  'game.bank.firstEntryTooLowEndTurn': 'Your first entry must be at least 50 points.',
  'game.bank.firstEntryTooLowBank': 'First entry must be ≥50 points.',
  'game.bank.freeScoringUnkept': 'Keep all scoring dice before saving your score.',
  'turn.segments': 'Scoring segments',
  'turn.bustBanner': 'Bust — no scoring dice',
  'turn.hotDice': 'All dice score! (Hot dice)',
  'turn.rescue': 'Rescue by five available',
  'turn.debug.player': 'Player',
  'turn.debug.rolls': 'Rolls',
  'turn.debug.current': 'Current score',
  'turn.debug.breakdown': 'Score breakdown',
  'turn.bannerDice': 'Dice from last roll',
      'privacy.title': 'Privacy Policy',
      'privacy.subtitle': 'Data processing rules for Thousand Dice of Contention',
      'privacy.updated': 'Last updated: March 2026',
    
      // 1. General Information
      'privacy.general.title': '1. General Information',
      'privacy.general.body1': 'This mobile game is Thousand Dice of Contention. User accounts are optional: you can play anonymously, but some features are enabled after signing in through an external identity provider.',
      'privacy.general.body2': 'The game does not use advertising or marketing trackers. Data is processed only to operate gameplay, account features, and game invites.',
    
      // 2. Data Collected
      'privacy.collected.title': '2. Data Collected',
      'privacy.collected.intro': 'The game saves only data necessary for functioning:',
      'privacy.collected.item1': 'nickname provided voluntarily by the user,',
      'privacy.collected.item2': 'gameplay data (e.g., game progress, scores, duration),',
      'privacy.collected.item3': 'random player identifier (UUID), generated locally on the device,',
      'privacy.collected.item4': 'account identifier and profile data received from the selected sign-in provider, such as display name, avatar, and in some cases email address,',
      'privacy.collected.item5': 'technical push tokens and device metadata required to deliver game invites.',
      'privacy.collected.outro': 'The game does not collect phone numbers, location data, or sell personal data. Email is processed only when a sign-in provider includes it in the authenticated session.',
    
      // 3. Purpose of Data Processing
      'privacy.purpose.title': '3. Purpose of Data Processing',
      'privacy.purpose.intro': 'Data is processed solely for the purpose of:',
      'privacy.purpose.item1': 'saving and synchronizing games,',
      'privacy.purpose.item2': 'enabling game continuation on the same device,',
      'privacy.purpose.item3': 'providing private stats, friends, and an invite inbox after sign-in,',
      'privacy.purpose.item4': 'delivering push notifications for game invites on native mobile apps.',
    
      // 4. Data Storage
      'privacy.storage.title': '4. Data Storage',
      'privacy.storage.body1': 'Data is not sold or shared with third parties for marketing purposes. Technical providers process only the minimum scope needed for sign-in and push delivery.',
    
      // 5. Security
      'privacy.security.title': '5. Security',
      'privacy.security.body1': 'Data is transmitted using encryption (HTTPS/TLS).',
      'privacy.security.body2': 'Access to data is limited solely to the functioning of the game.',
    
      // 6. Data Deletion
      'privacy.deletion.title': '6. Data Deletion',
      'privacy.deletion.intro': 'The user may at any time:',
      'privacy.deletion.item1': 'remove the app and sign out, which stops further push delivery to that device,',
      'privacy.deletion.item2': 'contact the developer to request deletion of account data and stored results,',
      'privacy.deletion.outro': 'Please include a game identifier, `friend_code`, or account email when available to help locate the data. Deletion is irreversible.',
    
      // 7. Contact
      'privacy.contact.title': '7. Contact',
      'privacy.contact.body': 'For privacy-related matters, please contact:',
      'privacy.contact.developerLabel': 'Developer:',
      'privacy.contact.developerName': 'Janek Rumianek',
      'privacy.contact.email': 'dice1k@outlook.com',
    
      'terms.title': 'Terms of Service',
      'terms.subtitle': 'Rules for using Thousand Dice of Contention',
      'terms.updated': 'Last updated: March 2026',
      'terms.acceptance.title': 'Acceptance of Terms',
      'terms.acceptance.body': 'By accessing or using Thousand Dice of Contention, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not use the game.',
      'terms.usage.title': 'Use of Service',
      'terms.usage.body': 'Thousand Dice of Contention is provided for personal entertainment purposes. You agree not to misuse the services or help anyone else to do so. The game can be used anonymously or with an optional user account.',
      'terms.disclaimer.title': 'Disclaimer',
      'terms.disclaimer.body': 'The game is provided "as is" without any warranties. We are not liable for any damages or losses related to your use of the game.',
      'terms.accounts.title': 'Accounts and invites',
      'terms.accounts.body': 'Google or Apple sign-in is optional and exists to unlock private stats, friends, invites, and native push notifications. You are responsible for using those features in line with the provider rules and for not sending abusive or unwanted invites to other players.',
      'terms.dataDeletion.title': 'Data deletion',
      'terms.dataDeletion.body': 'If you want to delete your account data, use the form available at the link below.',
      'terms.dataDeletion.link': 'Open the data deletion form',
      'terms.changes.title': 'Changes',
      'terms.changes.body': 'We reserve the right to modify these terms at any time. Continued use of the game signifies your acceptance of the updated terms.',
      'terms.contact.title': 'Contact',
      'terms.contact.body': 'For support or questions about these terms, contact us at:',
      'terms.contact.developerLabel': 'Developer:',
      'terms.contact.developerName': 'Janek Rumianek',
      'terms.contact.email': 'dice1k@outlook.com',
    };
    
